import { ReactNode } from 'react';

interface FormSectionProps {
  id?: string;
  title: string;
  icon?: ReactNode;
  count?: number;
  children: ReactNode;
  className?: string;
}

export default function FormSection({ id, title, icon, count, children, className = '' }: FormSectionProps) {
  return (
    <section id={id} className={`scroll-mt-24 rounded-2xl border border-line bg-base p-5 sm:p-6 space-y-4 ${className}`}>
      <h2 className="flex items-center gap-2.5 font-display font-extrabold tracking-[-0.02em] text-xl text-ink">
        {icon && <span className="text-primary">{icon}</span>}
        {title}
        {typeof count === 'number' && count > 0 && (
          <span className="text-xs font-semibold bg-primary/10 text-primary px-2 py-0.5 rounded-full">{count}</span>
        )}
      </h2>
      {children}
    </section>
  );
}
